import React from 'react';
import { Link } from 'react-router-dom';
import useFadeIn from '../../hooks/useFadeIn';
import { useAuth } from '../../hooks/useAuth';
import './footer.css';
import IconInstagram from '../../Images/optimized/instagram-our-place.webp';
import IconFacebook from '../../Images/optimized/facebook-our-place.webp';
import IconLinkedin from '../../Images/optimized/linkedin-our-place.webp';
import logo from '../../Images/optimized/our-place-logo-header.webp';

const SOCIAL = [
  { name: 'Instagram', href: 'https://www.instagram.com/joinourplace', icon: IconInstagram },
  { name: 'Facebook',  href: 'https://www.facebook.com/joinourplace',  icon: IconFacebook },
  { name: 'LinkedIn',  href: 'https://www.linkedin.com/company/joinourplace/', icon: IconLinkedin },
];

const Footer = () => {
  const { isAuthenticated } = useAuth();
  const footerRef = useFadeIn(0.5);
  const brandRef = useFadeIn(0.5);
  const donateRef = useFadeIn(0.5);
  const bottombarRef = useFadeIn(0.5);

  return (
    <>
      <footer ref={footerRef} className="footer fade-in">
        <div className="container">
          <div className="footer-content">
            <div ref={brandRef} className="fade-in footer-column footer-brand-column">
              <Link to="/">
                <img
                  src={logo}
                  alt="Join Our Place — home"
                  className="footer-logo"
                  width="80"
                  height="58"
                  loading="lazy"
                  decoding="async"
                />
              </Link>
            </div>
            <div ref={donateRef} className="fade-in footer-donate-column">
              <div className="footer-cta-row">
                {/* Members already have an account; /signup would only bounce them to /profile. */}
                {!isAuthenticated && (
                  <Link to="/signup?mode=signup" className="btn btn-primary footer-signup-btn">Sign Up</Link>
                )}
                <Link to="/donate" className="btn btn-outline-primary donate-btn">Donate</Link>
              </div>
              <div className="footer-social">
                <div className="social-row">
                  <p className="footer-follow-us">Follow Us</p>
                  {/* A list, so a screen reader announces "3 items" rather than
                      reading three unrelated images in a row. */}
                  <ul className="social-icons">
                    {SOCIAL.map(({ name, href, icon }) => (
                      <li key={name}>
                        <a
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`Our Place on ${name} (opens in a new tab)`}
                        >
                          <img
                            src={icon}
                            alt=""
                            className="social-icon"
                            width="40"
                            height="40"
                            loading="lazy"
                            decoding="async"
                          />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="review-row">
                  <a
                    className="footer-social-label"
                    href="https://www.facebook.com/joinourplace/reviews"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Leave us a review
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div ref={bottombarRef} className="footer-band fade-in">
        <div className="container">
          <div className="band-content">
            {/* Was hard-coded to 2025 and would have quietly gone stale. */}
            <p className="band-text">
              {new Date().getFullYear()} Join Our Place is a certified 501c3, EIN: 99-1612413
            </p>
            <nav className="band-links" aria-label="Legal">
              <Link className="band-link" to="/privacy">Privacy Policy</Link>
              <Link className="band-link" to="/terms">Terms of Use</Link>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
